import { Routes } from '@angular/router';
import { InnovaStaffCanActivate } from './shared/services/auth/innova-staff-can-activate.guard';

export const routes: Routes = [
  {
    path: 'home',
    data: { title: 'Home' },
    loadChildren: () => import('./overview/overview.module').then((m) => m.OverviewModule),
  },
  {
    path: 'learning-library',
    loadChildren: () => import('./learning-library/learning-library.module').then((m) => m.LearningLibraryModule),
    data: { title: 'Learning Library', breadcrumb: 'Learning Library' },
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'id_token',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'development',
    loadChildren: () => import('./pages/development/development.module').then((m) => m.DevelopmentModule),
    data: { title: 'Development', breadcrumb: 'Development' },
  },
  {
    path: 'business-intel',
    loadChildren: () => import('./business-intel/business-intel.module').then((m) => m.BusinessIntelModule),
    data: {
      title: 'Business Intelligence',
      breadcrumb: 'Business Intelligence',
    },
  },
  {
    path: 'support-center',
    loadChildren: () => import('./pages/support-center/support-center.module').then((m) => m.SupportCenterModule),
    canActivate: [InnovaStaffCanActivate],
    data: { title: 'Suport Center', breadcrumb: 'Support Center' },
  },
  {
    path: 'forbidden',
    loadChildren: () => import('./forbidden/forbidden.module').then((m) => m.ForbiddenModule),
  },
  {
    path: '**',
    loadChildren: () => import('./not-found/not-found.module').then((m) => m.NotFoundModule),
  },
];
